var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0645 0H1.93548C0.870968 0 0 0.857143 0 1.90476V12.381C0 12.7619 0.129032 13.1111 0.322581 13.4286C0.354839 13.5556 0.419355 13.6825 0.516129 13.7778C0.612903 13.873 0.741935 13.9365 0.870968 13.9683C1.19355 14.1905 1.54839 14.2857 1.93548 14.2857H18.0645C19.129 14.2857 20 13.4286 20 12.381V1.90476C20 0.857143 19.129 0 18.0645 0ZM18.7097 2.15873V11.8413L13.6774 7.14286L18.7097 2.15873ZM11.6774 7.30159H8.32258L2.19355 1.26984H17.7742L11.6774 7.30159ZM6.35484 7.14286L1.29032 12.127V2.15873L6.35484 7.14286ZM7.25806 8.03175L7.80645 8.57143H12.2258L12.7742 8.03175L18.0968 13.0159H18.0645H2.19355L7.25806 8.03175Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.428244fdbdf5df7060deba5f08eab977.svg";
export { ForwardRef as ReactComponent };